__turbopack_context__.v({
  "ant-select-selection-search": "SearchSelect-module__xRprXq__ant-select-selection-search",
  "searchSelect": "SearchSelect-module__xRprXq__searchSelect",
});
